<script lang="ts" setup>
import { CATALOG_PAGE_TYPES } from '~/constants/catalogPageTypes';
import type { CatalogPageData, CatalogResponse, OfferFull } from '~/types/Catalog';

const route = useRoute();
const catalogStore = useCatalogStore();
const categoryPageData = ref<CatalogPageData | null>(null);

const data = await catalogStore.getCatalogData();

await processData(data);

async function processData(data: CatalogResponse | null) {
  if (data) {
    if (import.meta.client) {
      if (data.type === CATALOG_PAGE_TYPES.REDIRECT) {
        await navigateTo(data.data.uri, { replace: true, external: true });
      }

      if (!route.hash) setTimeout(() => window.scrollTo(0, 0), 10);
    }

    if (data.type === CATALOG_PAGE_TYPES.CATEGORY_PAGE || data.type === CATALOG_PAGE_TYPES.SEO_CATEGORY_PAGE) {
      catalogStore.currentPageType = data.type;
      categoryPageData.value = data.data as CatalogPageData;
    } else if (data.type === CATALOG_PAGE_TYPES.OFFER_PAGE || data.type === CATALOG_PAGE_TYPES.OFFER_GROUP_PAGE) {
      catalogStore.currentPageType = data.type;
      catalogStore.selectedOffer = data.data as OfferFull;
    }
  }
}

watch(
  () => route.query,
  async () => {
    if (
      catalogStore.currentPageType === CATALOG_PAGE_TYPES.CATEGORY_PAGE ||
      catalogStore.currentPageType === CATALOG_PAGE_TYPES.SEO_CATEGORY_PAGE
    ) {
      const data = await catalogStore.getCatalogData();

      await processData(data);
    }
  },
);
</script>

<template>
  <div class="relative">
    <CategoryPage
      v-if="
        categoryPageData &&
        [CATALOG_PAGE_TYPES.CATEGORY_PAGE, CATALOG_PAGE_TYPES.SEO_CATEGORY_PAGE].includes(catalogStore.currentPageType)
      "
      :page-data="categoryPageData"
    />

    <ProductPage
      v-else-if="
        catalogStore.selectedOffer &&
        [CATALOG_PAGE_TYPES.OFFER_PAGE, CATALOG_PAGE_TYPES.OFFER_GROUP_PAGE].includes(catalogStore.currentPageType)
      "
    />
  </div>
</template>
